// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ShoppingCartOutlinedSvg from "@fishx/icons-svg/es/asn/ShoppingCartOutlined";
import FishxIcon from '../components/FishxIcon';

var ShoppingCartOutlined = function ShoppingCartOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: ShoppingCartOutlinedSvg
  }));
};

ShoppingCartOutlined.displayName = 'ShoppingCartOutlined';
export default React.forwardRef(ShoppingCartOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/ShoppingCartOutlined.js
// module id = 4103
// module chunks = 0